const INIT_STATE = {};

const addItem = (state, payload) => {
   if (cartExists(state, payload.shopId)) {
      // If item already exists - don't add it again
      if (findItem(state, payload.shopId, payload.addedItem.item_id))
         return [...state[payload.shopId].addedItems];
      return [...state[payload.shopId].addedItems, payload.addedItem];
   }
   return [payload.addedItem];
};

const changeQuantity = (state, payload) => {
   if (cartExists(state, payload.shopId)) {
      const itemToChange = findItem(state, payload.shopId, payload.itemId);
      if (itemToChange)
         return state[payload.shopId].addedItems.map((item) => {
            if (item.item_id === payload.itemId)
               return {
                  ...item,
                  quantity: payload.quantity
               };
            return item;
         });
      return [...state[payload.shopId].addedItems];
   }
};

const removeItem = (state, payload) => {
   if (cartExists(state, payload.shopId))
      return state[payload.shopId].addedItems.filter((item) => item.item_id !== payload.itemId);
};

const findItem = (state, shopId, itemId) => {
   return state[shopId].addedItems.find((item) => item.item_id === itemId);
};

const cartExists = (state, shopId) => {
   if (state[shopId]?.addedItems) return true;
   return false;
};

export default (state = INIT_STATE, action) => {
   switch (action.type) {
      case "SET_CART": {
         return {
            ...state,
            [action.payload.shopId]: {
               addedItems: [...action.payload.addedItems]
            }
         };
      }
      case "ADD_CART_ITEM": {
         return {
            ...state,
            [action.payload.shopId]: {
               ...state[action.payload.shopId],
               addedItems: addItem(state, action.payload)
            }
         };
      }
      case "CHANGE_PRODUCT_QUANTITY": {
         return {
            ...state,
            [action.payload.shopId]: {
               ...state[action.payload.shopId],
               addedItems: changeQuantity(state, action.payload)
            }
         };
      }
      case "REMOVE_CART_ITEM": {
         return {
            ...state,
            [action.payload.shopId]: {
               ...state[action.payload.shopId],
               addedItems: removeItem(state, action.payload)
            }
         };
      }
      case "CLEAR_CART": {
         if (!cartExists(state, action.payload)) return { ...state };
         return {
            ...state,
            [action.payload]: {
               ...state[action.payload],
               addedItems: []
            }
         };
      }
      case "SET_HAS_BEEN_FETCHED": {
         return {
            ...state,
            [action.payload]: {
               ...state[action.payload],
               wasFetched: true
            }
         };
      }
      default:
         return state;
   }
};
